<template>
    <div class="page-container">
        <div class="page-content">
            <!-- <img src="../../assets/withdraw-succ.png" alt="" class="result-pic">
            <div class="result-text">进货成功</div>
            <div class="asset-text">您的进货单已经交易成功，合作愉快</div>
            <div class="btn-line">
                <div class="btn-backindex">返回首页</div>
                <div class="btn-seeorder">查看订单</div>
            </div> -->

            <img src="../../assets/withdraw-fail.png" alt="" class="result-pic">
            <div class="result-text">进货失败</div>
            <div class="asset-text">您的进货订单因系统原因进货失败，可重新进货</div>
            <div class="btn-line">
                <div class="btn-backindex">返回首页</div>
                <div class="btn-seeorder">重新提货</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
.page-container{
    background: #f5f5f5;
    min-height: calc(100vh - 46px);
    box-sizing: border-box;
    padding:15px;
    .page-content{
        background:#fff;
        border-radius: 4px;
        text-align: center;
        padding-top: 36px;
        padding-bottom: 30px;
        .result-pic{
            width:60px;
            height:60px;
            margin-bottom: 16px;
        }
        .result-text{
            font-size: 20px;
            color:#333;
            line-height: 28px;
            margin-bottom: 10px;
        }
        .asset-text{
            color:#666;
            font-size: 14px;
            margin-bottom: 35px;
        }
        .btn-line{
            padding:0 50px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .btn-backindex{
                border:1px solid #C8C8C8;
                border-radius: 26px;
                width:110px;
                text-align: center;
                font-size: 16px;
                color:#333;
                height:40px;
                line-height: 40px;
            }
            .btn-seeorder{
                border-radius: 26px;
                width:110px;
                text-align: center;
                font-size: 16px;
                color:#fff;
                height:40px;
                line-height: 40px;
                background: linear-gradient(180deg, #55B3FF 0%, #3189F6 100%);
            }
        }
    }
}
</style>